import {
    FETCHING_DATASOURCE_TRANSACTIONS,
    FETCHING_DATASOURCE_TRANSACTIONS_SUCCEEDED,
    FETCHING_DATASOURCE_TRANSACTIONS_FAILED,
    FETCHING_DATASOURCE,
    FETCHING_DATASOURCE_SUCCEEDED,
    FETCHING_DATASOURCE_FAILED,
    FETCHING_DATASOURCE_MAPPINGS,
    FETCHING_DATASOURCE_MAPPINGS_SUCCEEDED,
    FETCHING_DATASOURCE_MAPPINGS_FAILED,
    FETCHING_DATASOURCE_CHILD_MAPPINGS,
    FETCHING_DATASOURCE_CHILD_MAPPINGS_SUCCEEDED,
    FETCHING_DATASOURCE_CHILD_MAPPINGS_FAILED,
    TRIGGER_DATASOURCE_MAPPING_SYNC,
    TRIGGER_DATASOURCE_MAPPING_SYNC_SUCCEDDED,
    TRIGGER_DATASOURCE_MAPPING_SYNC_FAILED
} from "constants/actionTypes";
import _, { result } from "lodash";

const initialState = {
    browse: {
        loading: false,
        requests: 0,
        items: [],
        syncMapping: {
            id: null,
            loading: false
        }
    },
    transactions: {
        items: [],
        loading: false,
        pagination: {
            currentPage: -1,
            totalPages: 1,
            recordsPerPage: 10,
            totalRecordsCount: 0,
        },
        error: null,
    },
};

function datasourceReducer(state = initialState, action) {
    switch (action.type) {
        case FETCHING_DATASOURCE_TRANSACTIONS: {
            const { page, filters } = action.payload;

            if (page === 0) {
                return Object.assign({}, state, {
                    ...state,
                    transactions: {
                        loading: filters.refresh ? true : state.loading,
                        items: filters.refresh ? [] : state.items,
                        pagination: {
                            currentPage: -1,
                            totalPages: 1,
                            recordsPerPage: 20,
                            totalRecordsCount: filters.refresh
                                ? 0
                                : state.transactions.pagination.totalRecordsCount,
                        },

                    }
                });
            }

            return Object.assign({}, state, { ...state, transactions: { loading: true, ...state.transactions } });
        }

        case FETCHING_DATASOURCE_TRANSACTIONS_SUCCEEDED: {
            var items = state.transactions.items;

            var {
                currentPage,
                totalPages,
                recordsPerPage,
                totalRecordsCount,
                records = [],
            } = action.payload;

            if (currentPage !== 0) {
                items = [...state.transactions.items, ...records];
            } else {
                items = records;
            }

            return Object.assign({}, state, {
                ...state,
                transactions: {
                    loading: false,
                    items: items,
                    pagination: {
                        ...state.pagination,
                        currentPage,
                        totalPages,
                        recordsPerPage,
                        totalRecordsCount,
                    },
                }
            });
        }

        case FETCHING_DATASOURCE_TRANSACTIONS_FAILED: {
            return Object.assign({}, state, {
                ...state,
                transactions: {
                    loading: false,
                    items: [],
                    pagination: {
                        currentPage: -1,
                        totalPages: 1,
                        recordsPerPage: 20,
                        totalRecordsCount: 0,
                    },
                }
            });
        }

        case FETCHING_DATASOURCE: {
            return Object.assign({}, state, {
                ...state,
                browse: {
                    requests: state.browse.requests + 1,
                    loading: true,
                    items: []
                }
            })
        }

        case FETCHING_DATASOURCE_SUCCEEDED: {
            return Object.assign({}, state, {
                ...state,
                browse: {
                    ...state.browse,
                    loading: false,
                    items: action.payload,
                    requests: state.browse.requests - 1
                }
            })
        }

        case FETCHING_DATASOURCE_FAILED: {
            return Object.assign({}, state, {
                ...state,
                browse: {
                    ...state.browse,
                    loading: false
                }
            })  
        }
        case FETCHING_DATASOURCE_CHILD_MAPPINGS:
        case FETCHING_DATASOURCE_MAPPINGS: {
            return Object.assign({}, state, {
                ...state,
                browse: {
                    ...state.browse,
                    loading: true,
                    requests: state.browse.requests + 1
                }
            })
        }

        case FETCHING_DATASOURCE_CHILD_MAPPINGS_SUCCEEDED:
        case FETCHING_DATASOURCE_MAPPINGS_SUCCEEDED: {

            let items = state.browse.items;
            let listOfItemIds = items.map((item) => item.id);

            let records = action.payload;

            if (records !== null && records !== undefined && records.length > 0) {
                for (let i = 0; i < records.length; i++) {
                    let item = records[i];
                    if (listOfItemIds.indexOf(item.id) === -1) {
                        items.push(item);
                    }
                }
            }

            const groupedData = items.reduce((result, item) => {
                let { parent } = item;

                if (!result[parent]) {
                    result[parent] = [];
                }

                result[parent].push(item.id);

                return result;
            }, {});


            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (item.id !== '0') {
                    let children = groupedData[item.id];
                    if (children !== null && children !== undefined) {
                        item.children = children;
                    }
                }
            }

            return Object.assign({}, state, {
                ...state,
                browse: {
                    loading: false,
                    items: items,
                    requests: state.browse.requests - 1
                }
            })
        }

        case TRIGGER_DATASOURCE_MAPPING_SYNC: {

            let mappingId = action.payload.mappingId;

            return Object.assign({}, state, {
                ...state,
                browse: {
                    ...state.browse,
                    syncMapping: {
                        id: mappingId,
                        loading: true
                    }
                }
            });
        }

        case TRIGGER_DATASOURCE_MAPPING_SYNC_SUCCEDDED: {
            let items = state.browse.items;
            for (let i = 0; i < items.length; i++) {
                let item = items[i];

                if (item.dataSourceMappingId === action.payload.id && item.status !== null && item.status !== undefined) {
                    item.status = action.payload.status;
                    break;
                }
            }

            return Object.assign({}, state, {
                ...state, browse: {
                    ...state.browse,
                    items: items,
                    syncMapping: {
                        ...state.browse.syncMapping,
                        loading: false
                    }
                }
            });
        }

        case TRIGGER_DATASOURCE_MAPPING_SYNC_FAILED: {
            return Object.assign({}, state, {
                ...state,
                browse: {
                    ...state.browse,
                    syncMapping: {
                        ...state.browse.syncMapping,
                        loading: false
                    }
                }
            });
        }

        default:
            return state;
    }

}

export { datasourceReducer };